"use strict";
const queryparam = __GMK_VERSIONING_QUERY_PARAM__;
const build_version = __GMK_BUILD_PACKAGE_VERSION__;
(() => {
    try {
        const _WINDOW = window;
        const params = Object.fromEntries(new URLSearchParams(window.location.search).entries());
        const version = params[queryparam];
        //exit early if we encounter the following
        const versionNeedsToChange = !!version;
        if (!versionNeedsToChange) {
            return;
        }
        const isProduction = process.env.NODE_ENV != 'development';
        if (isProduction) {
            return;
        }
        const isExpectedVersion = build_version == version;
        if (isExpectedVersion) {
            return console.debug('[@growmark/versioning-vue]: loading version', build_version);
        }
        const infinateLoop = _WINDOW._GMK_VERSION_LOADING >= 2;
        if (infinateLoop) {
            throw `[@growmark/versioning-vue]: issue switching to ${version}`;
        }
        /** Handle version switching logic given assumptions about the vue file generation process */
        const chunk_vendors_js = document.createElement('script');
        chunk_vendors_js.setAttribute('defer', '');
        chunk_vendors_js.setAttribute('type', 'text/javascript');
        chunk_vendors_js.setAttribute('src', `/js/chunk-vendors.${version}.js`);
        const app_js = document.createElement('script');
        app_js.setAttribute('defer', '');
        app_js.setAttribute('type', 'text/javascript');
        app_js.setAttribute('src', `/js/app.${version}.js`);
        const chunk_vendors_css = document.createElement('link');
        chunk_vendors_css.setAttribute('rel', 'stylesheet');
        chunk_vendors_css.setAttribute('href', `/css/chunk-vendors.${version}.css`);
        const app_css = document.createElement('link');
        app_css.setAttribute('rel', 'stylesheet');
        app_css.setAttribute('href', `/css/app.${version}.css`);
        document.head.appendChild(chunk_vendors_js);
        document.head.appendChild(app_js);
        document.head.appendChild(chunk_vendors_css);
        document.head.appendChild(app_css);
        //set version information for reload
        _WINDOW._GMK_PREVIOUS_VERSION = build_version;
        _WINDOW._GMK_VERSION_LOADING = (_WINDOW._GMK_VERSION_LOADING + 1) || 1;
        //clear webpack cache (if needed)
        Object.keys(_WINDOW)
            .filter(name => name.indexOf('webpack') == 0)
            .forEach(key => { delete _WINDOW[key]; });
        throw `[@growmark/versioning-vue]: switching version ${build_version} -> ${version || '???'} : ${new Date().getTime()}`; //throw this error
    }
    catch (error) {
        if (typeof error == 'string' && error.indexOf('@growmark/versioning-vue') > -1) {
            throw error;
        }
        console.debug('[@growmark/versioning-vue]: unexpected issue processing version change', error);
    }
})();
//# sourceMappingURL=index.js.map